import React from "react";

import { useGeneralizer } from ".";

/**
 *
 * @param {{
 *  organization: string,
 *  userId: string,
 *  componentsMap: {[key: string]: JSX.Element},
 *  Default: JSX.Element,
 *  rest: any[]
 * }} props
 */
export function Generalizer({ organization, userId, componentsMap, Default, ...rest }) {
  const Component = useGeneralizer(componentsMap, Default, { userId, organization });

  if (!Component) return <></>;

  return <Component {...rest} />;
}
